import React from 'react';
import { NextPage } from 'next';
import Link from 'next/link';
import styled from 'styled-components';
import { Link as StyledLink } from '@makeship/core';
import Head from '../components/Head';
import { H1, P1, P1Styles } from '../components/Typography';

import config from '../../config.json';

const { routes } = config;

const Error404PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 638px;
  padding-top: 16px;
  background-image: url('/assets/404-art.png');
  background-repeat: no-repeat;
  background-size: ${({ theme }) => theme.breakpoints.maxContent}px auto;
  background-position: 50% 25%;
  @media (max-width: ${({ theme }) => theme.breakpoints.maxContent}px) {
    background-size: 100% auto;
    background-position: center 50%;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    height: 683px;
    background-position: center -8%;
    background-image: url('/assets/404-art-mobile.png');
    background-size: 460px auto;
    margin-top: -16px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    height: 638px;
    background-position: center top;
    background-image: url('/assets/404-art-mobile.png');
    background-size: 360px; auto;
  }
  @media (max-width: 360px) {
    background-size: 100%; auto;
  }
`;

const Error404Body = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-bottom: 48px;
  min-height: 504px;
  max-width: 80%;
  @media (max-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    width: 100%;
    position: relative;
    top: 48px;
    min-height: 0px;
    justify-content: flex-end;
    margin-bottom: 64px !important;
    margin-top: 64px;
    max-width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    margin-bottom: 64px !important;
  }
`;

const Error404Bottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  width: 100%;
  max-width: 1312px;
  @media (max-width: ${({ theme }) => theme.breakpoints.maxContent}px) {
    max-width: 100%;
    padding-left: 64px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    margin-top: 64px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    padding-left: 16px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    padding-left: 16px;
    margin-top: 64px;
  }
`;

const Error404Links = styled.div`
  display: flex;
  flex-direction: row;
`;

const ErrorHeader = styled(H1)`
  font-size: 92px;
  margin-bottom: 24px;
  text-transform: uppercase;
  @media (max-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    font-size: 48px;
    margin-bottom: 8px;
  }
`;

const ErrorSubheading = styled(P1)`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  text-align: center;
`;

const ErrorBody = styled(P1)`
  width: 40%;
  line-height: 27px;
  margin-bottom: 24px;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.largeTablet}px) {
    width: 100%;
    margin-bottom: 0px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const ErrorBottomHeader = styled(P1)`
  font-weight: bold;
  margin-bottom: 8px;
`;

const BottomLink = styled(StyledLink.Primary)`
  ${P1Styles};
  color: ${({ theme }) => theme.colors.primary} !important;
  display: block;
  margin-right: 32px;
  cursor: pointer;
`;

const HomeLink = styled(BottomLink)`
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    display: none;
  }
`;

const Error404Page: NextPage = () => (
  <>
    <Head title="404" />
    <Error404PageWrapper>
      <Error404Body>
        <ErrorHeader>Oops</ErrorHeader>
        <ErrorSubheading>404 Error - Page Not Found</ErrorSubheading>
        <ErrorBody>This page got lost in the Makeship Universe.</ErrorBody>
      </Error404Body>
      <Error404Bottom>
        <ErrorBottomHeader>Try these Links:</ErrorBottomHeader>
        <Error404Links>
          <Link href={routes.home}>
            <HomeLink>Home</HomeLink>
          </Link>
          <Link href={routes.shopLive}>
            <BottomLink>Live Campaigns</BottomLink>
          </Link>
          <Link href={routes.helpCenter} passHref>
            <BottomLink>Help Center</BottomLink>
          </Link>
        </Error404Links>
      </Error404Bottom>
    </Error404PageWrapper>
  </>
);

export default Error404Page;
